import api from './index';


const fileList = (params) => {
    return api.raw.get('/files/', { params, isAuth: false })
}

const fileUpload = (data) => {
    return api.raw.post('/files/', data, { isAuth: true})
}


const fileDownload = (id) => {
    return api.raw.get(`/files/${id}/`, { isAuth: false, responseType: 'blob' })
}

const fileTags = (params={}) => {
    return api.raw.get('/files/tag_info/', { params, isAuth: false })
}

const fileTag = (id) => {
    return api.raw.get(`/files/tag_info/${id}/`, { isAuth: false })
}

const fileDelete = (id) => {
    return api.raw.delete(`/files/${id}/`, { isAuth: true })
}

export default {
    fileList,
    fileUpload,
    fileDownload,
    fileTags,
    fileTag,
    fileDelete
}